import { Modal } from "react-bootstrap";
import "./successmodal.scss";
import cross from "images/cross.svg";
import success from "images/success.svg";
import iconError from "images/iconError.svg";
import { inject, observer } from "mobx-react";

const ApplicationSuccessModalFromVacancy = ({ errorWithoutDate, ...props }) => {
  return (
    <Modal {...props} aria-labelledby="contained-modal-title-vcenter" centered backdrop="static">
      <Modal.Body className="success-modal">
        <p>
          <img src={cross} className="success-modal-crossimg" onClick={props.onHide} alt="" />
        </p>
        <div className="success-modal-content">
          {errorWithoutDate ? (
            <>
              <p className="app-success-modal-title">Ваш отклик не отправлен</p>
              <p className="app-success-modal-text">{errorWithoutDate}</p>
              <img src={iconError} className="app-success-modal-img" onClick={props.onHide} alt="" />
            </>
          ) : (
            <>
              <p className="app-success-modal-title">Ваш отклик отправлен</p>
              <p className="app-success-modal-text">Проверить статус отклика можно в разделе “Мои кандидаты”</p>
              <img src={success} className="app-success-modal-img" onClick={props.onHide} alt="" />
            </>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default inject(({ candidatesStore }) => {
  const { errorWithoutDate } = candidatesStore;

  return {
    errorWithoutDate,
  };
})(observer(ApplicationSuccessModalFromVacancy));
